import { useState, useCallback } from 'react';
import { GetPricingRequest } from '../types/PricingTypes';
import { PricingViewModel } from '../types/PricingViewModels';
import { GetPricingInteractor } from './GetPricingInteractor';
import { PricingPresenter } from './PricingPresenter';
import { B2BPricingDataRepository, B2CPricingDataRepository } from './PricingDataRepository';

export const usePricingController = (audience: "b2b" | "b2c") => {
  const [viewModel, setViewModel] = useState<PricingViewModel>({
    tiers: [],
    loading: false,
    error: null,
    lastUpdated: ''
  });

  const loadPricing = useCallback(async (request?: GetPricingRequest) => {
    // Dependency injection following Clean Architecture
    const repository = audience === "b2b" ? new B2BPricingDataRepository() : new B2CPricingDataRepository();
    const presenter = new PricingPresenter(setViewModel);
    const interactor = new GetPricingInteractor(repository, presenter);

    // Show loading state
    presenter.presentLoadingState();

    // Execute use case
    const defaultRequest: GetPricingRequest = {
      includeHiddenTiers: false,
      ...request
    };

    await interactor.getPricingConfiguration(defaultRequest);
  }, []);

  return {
    viewModel,
    loadPricing
  };
};